export const examples = ['TAO OR Bittensor']
